import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter, map } from "rxjs/operators";
import { SagaStatusEventMessage } from "~app/common/events/saga/SagaStatusEventMessage";
import { SagaStatusEventMessageArbetsorderData } from "~app/common/events/saga/SagaStatusEventMessageArbetsorderData";
import { ObjectUtils } from "~app/common/utils/object-utils";

export interface IEvent {
    $type: string;
}

export interface IEventTransferObject {
    events: IEvent[];
}
@Injectable({
    providedIn: "root"
})

export class EventService {

    private readonly events = new Subject<IEventWrapper>();

    subscribeEvent = <T extends IEvent>($type: string): Observable<T> => this.events
        .asObservable()
        .pipe(
            filter(g => g.$type === $type),
            map(g => g.wrapped as T)
        );

    subscribeSagaType = <T extends IEvent>(sagaEventMessageType: string): Observable<T> => this.events
        .asObservable()
        .pipe(
            filter(g => g.$type === sagaEventMessageType),
            map(g => g.wrapped as T)
        );

    subscribeAllArbetsorderSaga = (sagaType: string = null): Observable<SagaStatusEventMessage<SagaStatusEventMessageArbetsorderData>> => this.events
        .asObservable()
        .pipe(
            filter(g => g.wrapped?.data?.messageType === "Arbetsorder"),
            map(g => g.wrapped as SagaStatusEventMessage<SagaStatusEventMessageArbetsorderData>),
            filter(g => g.sagaType === sagaType || !ObjectUtils.hasValue(sagaType))
        );

    emit = <T extends IEvent>(t: T) => {
        const copy = {
            $type: this.trimType(t.$type),
            wrapped: t
        };
        this.events.next(copy);
    };

    private trimType(type: string): string {
        const csvParts = type.split(",");
        if (csvParts.length === 1) {
            return type;
        }
        const namespaceType = csvParts[0];
        return namespaceType.split(".").slice(-1)[0];
    }
}

interface IEventWrapper {
    $type: string;
    wrapped: any;
}
